/**
 * Bridges the module-scope {@link subscribeApiError} bus to the design-system
 * Toast provider, so API failures raised inside `createApiClient`'s
 * interceptor become visible error toasts instead of silent rejections.
 *
 * Renders nothing. Mount it once, inside the app's `<ToastProvider>`.
 *
 * Pure infra with no tenant-facing fields — deliberately NOT registered as a
 * configurable component (see CLAUDE.md "Configurable Components", opt-out for
 * chrome/infra).
 */

import { useEffect } from 'react';
import { useToast } from '@components/base/feedback';
import { subscribeApiError } from './apiErrorBus';

/** Toast title used for every surfaced API failure. */
export const API_ERROR_TOAST_TITLE = 'Erreur';

export function ApiErrorToaster(): null {
  const { toast } = useToast();

  useEffect(
    () =>
      subscribeApiError((event) => {
        toast({
          variant: 'error',
          title: API_ERROR_TOAST_TITLE,
          message: event.message,
        });
      }),
    [toast],
  );

  return null;
}

ApiErrorToaster.displayName = 'ApiErrorToaster';
